import { render, staticRenderFns } from "./AppealUsers.vue?vue&type=template&id=0faaa816&scoped=true"
import script from "./AppealUsers.vue?vue&type=script&lang=js"
export * from "./AppealUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faaa816",
  null
  
)

export default component.exports